import { ServiceAdminService } from '../Providers/service-admin.service';
import { AdminComponentComponent } from './admin-component.component';
import { AdminComponentRoutingModule } from './admin-component-routing.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CompteDetailsComponent } from './compte-details/compte-details.component';
import { AddCompteServerComponent } from './add-compte-server/add-compte-server.component';
import { ComptesServerComponent } from './comptes-server/comptes-server.component';
import { ErrorComponent } from '../error/error.component';
import { TooltipModule } from "ngx-tooltip";
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ArchiveComponent } from './archive/archive.component';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MyDatePickerModule } from 'mydatepicker';
/**
 * created by AHMED HAYEL
 * 
 */

@NgModule({
  declarations: [
    DashboardComponent,
    AdminComponentComponent,
    CompteDetailsComponent,
    AddCompteServerComponent,
    ComptesServerComponent,

    ArchiveComponent
  ],
  imports: [
    FormsModule,
    HttpModule,
    CommonModule,
    AdminComponentRoutingModule,
    TooltipModule,
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    MyDatePickerModule
  ],
  providers: [ServiceAdminService],
})
export class AdminComponentModule { }



// WEBPACK FOOTER //
// ./src/app/admin-component/admin-component.module.ts